<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>Edit Segment</h2>
        </div>
        <div slot="body">
            <div class="col-sm-12 py-3">
                <segments-form :segment="tempSegment"></segments-form>
                <!-- <div class="d-flex justify-content-end">
                    <button class="btn action" @click="deleteChannel(tempSegment)">Delete</button>
                </div> -->
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal'
    import segmentsForm from './segmentsForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                tempSegment: null
            }
        },
        created: function() {
            this.tempSegment = JSON.parse(JSON.stringify(this.getSelectedSegment))
        },
        computed: {
            ...mapGetters([
                'getSelectedSegment'
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'setSelectedSegment',
                'deleteSegment',
                'updateSegment',
                'downloadSegments'
            ]),
            deleteChannel: function(segment) {
                this.deleteSegment(segment)
            },
            save: function() {
                this.updateSegment(this.tempSegment).then(success => {
                    if(success == true){
                        this.closeModal();
                        this.downloadSegments();
                    }
                })
            },
            close: function() {
                this.setSelectedSegment(null)
                this.closeModal();
            },
        },
        components: {
            Modal,
            segmentsForm
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// editSegment.vue?37636436